import { IC_CONTRACTADDRESS } from '../constants/apiPaths';

export const getIcLink = (tokenAddress, chainName) => {
    const icContractAddress = IC_CONTRACTADDRESS;

    const lowerCaseChainName = chainName?.toLowerCase();

    switch (lowerCaseChainName) {
        case 'solana':
            return `https://explorer.solana.com/address/${tokenAddress}`;
        case 'base':
            return `https://opensea.io/item/base/${icContractAddress}/${tokenAddress}`;
        case 'base sepolia':
            return `https://opensea.io/item/base/${icContractAddress}/${tokenAddress}`;
        case 'optimism':
            return `https://opensea.io/item/optimism/${icContractAddress}/${tokenAddress}`;
        case 'arbitrum':
            return `https://opensea.io/item/arbitrum/${icContractAddress}/${tokenAddress}`;
        case 'celo':
            return `https://rarible.com/token/celo/${icContractAddress}:${tokenAddress}`;
        default:
            return null;
    }
};
